import React, { useState, useEffect } from "react";
import axios from "axios";
import colors from "../Constant/colors";



const sessionId = localStorage.getItem("currentSessionId");

function Permissions() {
  const [activeRole, setActiveRole] = useState("");
  const [members, setMembers] = useState([]);
  const [selectedMemberId, setSelectedMemberId] = useState("");
  const [permissions, setPermissions] = useState({});
  const [loadingMembers, setLoadingMembers] = useState(false);
  const [loadingPermissions, setLoadingPermissions] = useState(false);
  const [roles, setRoles] = useState([]);
  /* 🔹 FETCH USERS WHEN ROLE CHANGES */
useEffect(() => {
  setMembers([]);
  setSelectedMemberId(null);
  setPermissions({});

  if (activeRole) {
    fetchUsersByDesignation(activeRole);
  }
}, [activeRole]);


  /* 🔹 FETCH OTHER ROLES */
  const fetchUsersByRole = async (role) => {
    try {
      setLoadingMembers(true);
      const res = await axios.get(
        ` ${process.env.REACT_APP_API_BASE_URL}/api/users/by-role/${role}`
      );

      setMembers(
        res.data.map((u) => ({
          id: u._id,
          name: u.name,
        }))
      );
    } catch (err) {
      setMembers([]);
    } finally {
      setLoadingMembers(false);
    }
  };

  /* 🔹 FETCH PERMISSIONS */
const fetchPermissions = async (memberId) => {
  try {
    setLoadingPermissions(true);

    const res = await axios.get(
      ` ${process.env.REACT_APP_API_BASE_URL}/api/users/permissions/${memberId}`,
      { params: { sessionId: localStorage.getItem("currentSessionId") } }
    );

    setPermissions(prev => ({
      ...prev,
      [memberId]: res.data.permissions || {},
    }));
  } catch (err) {
    console.error("Permission fetch error", err);
    setPermissions(prev => ({
      ...prev,
      [memberId]: {},
    }));
  } finally {
    setLoadingPermissions(false);
  }
};

  /* 🔹 SAVE PERMISSIONS */
const savePermissions = async () => {
  try {
    const sessionId = localStorage.getItem("currentSessionId");

    await axios.put(
      ` ${process.env.REACT_APP_API_BASE_URL}/api/users/permissions/${selectedMemberId}`,
      {
        permissions: permissions[selectedMemberId],
        sessionId
      }
    );

    alert("Permissions updated successfully");
  } catch (err) {
    console.error(err);
    alert("Failed to update permissions");
  }
};



//fetch degnation
useEffect(() => {
  const fetchRoles = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/allDesignations/allroles`,
        { params: { sessionId: localStorage.getItem("currentSessionId") } }
      );

      console.log("RAW DESIGNATIONS =>", res.data);

      const names = res.data
        .map(d => d.designationName?.trim())
        .filter(Boolean); // remove undefined / empty

      console.log("EXTRACTED NAMES =>", names);

const finalRoles = names
  .filter(n => n.toLowerCase() !== "teacher")
  .sort((a, b) => a.localeCompare(b));

setRoles(finalRoles);

// set default role automatically
if (finalRoles.length > 0) {
  setActiveRole(finalRoles[0]);
}


      console.log("FINAL ROLES =>", finalRoles);

      setRoles(finalRoles);
    } catch (err) {
      console.error(" Failed to fetch roles", err);
    }
  };

  fetchRoles();
}, []);


const fetchUsersByDesignation = async (designation) => {
  try {
    setLoadingMembers(true);

    const res = await axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/roles/by-designation`,
      {
        params: {
          designation,
          sessionId:localStorage.getItem("currentSessionId")
        }
      }
    );

    // Now map to Teacher / NonTeachingStaff names
    const formatted = await Promise.all(
      res.data.map(async (user) => {
        // fetch teacher or non-teacher detail
        if (user.usertype === "teacher") {
          const t = await axios.get(
            ` ${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${user.userId}`,
            { params: { sessionId } }
          );
          return {
            id: user.userId,
            name: `${t.data.firstName} ${t.data.lastName}`
          };
        } else {
          return {
            id: user.userId,
            name: user.username
          };
        }
      })
    );

    setMembers(formatted);
  } catch (err) {
    console.error("fetchUsersByDesignation error", err);
    setMembers([]);
  } finally {
    setLoadingMembers(false);
  }
};


  const selectedMember = members.find((m) => m.id === selectedMemberId);

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-6">

        {/* 🔹 ROLES */}
        <div className="bg-white rounded-xl shadow p-4">
          <h2 className="font-bold mb-4">Roles</h2>
          {roles.map((r) => (
            <div
              key={r}
              onClick={() => setActiveRole(r)}
              className={`p-3 mb-2 rounded cursor-pointer transition ${activeRole === r
                  ? "bg-blue-600 text-white"
                  : "bg-gray-100 hover:bg-gray-200"
                }`}
            >
              {r}
            </div>
          ))}
        </div>

        {/* 🔹 MEMBERS + PERMISSIONS */}
        <div className="md:col-span-2 bg-white rounded-xl shadow p-4">
          <h2 className="font-bold mb-3">
            Role: <span className="text-blue-600">{activeRole}</span>
          </h2>

          {/* MEMBERS */}
          <div className="mb-4">
            <p className="font-semibold mb-2">Members</p>

            {loadingMembers ? (
              <p className="text-sm text-gray-500">Loading...</p>
            ) : members.length === 0 ? (
              <p className="text-sm text-gray-500">No users found.</p>
            ) : (
              <div
                className="space-y-2 overflow-y-auto border rounded p-2"
                style={{ maxHeight: "220px" }}
              >
                {members.map((m) => (
                  <div
                    key={m.id}
                    onClick={() => {
                      setSelectedMemberId(m.id);

                      // IMPORTANT FIX
                      setPermissions((prev) => ({
                        ...prev,
                        [m.id]: prev[m.id] || {},
                      }));

                      fetchPermissions(m.id);
                    }}
                    className={`p-3 rounded cursor-pointer transition ${selectedMemberId === m.id
                        ? "bg-blue-100 border border-blue-400"
                        : "bg-gray-100 hover:bg-gray-200"
                      }`}
                  >
                    {m.name}
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* 🔹 PERMISSION TABLE */}
         {selectedMemberId && permissions[selectedMemberId] && (
  <div
    className="border rounded overflow-y-auto"
    style={{ maxHeight: "350px" }}  
  >
    <table className="w-full text-sm">
      <thead className="bg-gray-200 sticky top-0 z-10">
        <tr>
          <th className="p-2 text-left">Permission</th>
          <th className="p-2 text-center">Allowed</th>
        </tr>
      </thead>

      
      <tbody>

        {Object.keys(permissions[selectedMemberId] || {}).map((key) => (
  <tr key={key} className="border-t">
    <td className="p-2 font-medium">
      {key.replace(/_/g, " ").toUpperCase()}
    </td>
    <td className="text-center">
      <input
        type="checkbox"
        checked={permissions[selectedMemberId]?.[key] === true}
        onChange={() =>
          setPermissions(prev => ({
            ...prev,
            [selectedMemberId]: {
              ...prev[selectedMemberId],
              [key]: !prev[selectedMemberId]?.[key]
            }
          }))
        }
      />
    </td>
  </tr>
))}

      </tbody>
    </table>
  </div>
)}

          {selectedMemberId && (
            <div className="mt-4 text-right">
              <button
                onClick={savePermissions}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
              >
                Save Permissions
              </button>
            </div>
          )}


        </div>
      </div>
    </div>
  );
}

export default Permissions;
